import React from 'react';
import _ from 'lodash';

class Time extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { from, to, onChange, onBlur } = this.props;
    const handleChange = (e) => {
      onChange({ name: e.target.name, value: e.target.value });
    };
    const handleBlur = (e) => {
      onBlur({ name: e.target.name, value: e.target.value });
    };
    return (
      <div class={`inputContainer`}>
        <input
          type="time"
          id="timeStart"
          name="from"
          class={`timelog-time`}
          min="00:00"
          max="23:59"
          value={from}
          required
          onChange={handleChange}
          onBlur={handleBlur}
        />{' '}
        -{' '}
        <input
          type="time"
          id="timeEnd"
          name="to"
          class={`timelog-time`}
          min="00:00"
          max="23:59"
          value={to}
          required
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
    );
  }
}

export default Time;
